import React, { Component } from 'react';
import { CUSTOM_CELLS } from '../../../js/customElements/customCell';
import { Singleton } from '../../../js/Singleton';

import { rightArrow, leftArrow, firstPage, lastPage } from '../../../Images/Images';
export default class TableComponent extends Component {
  // PROPS:
  // customCell : Nombre de la celda que lo va a mapear, esta celda deber ir en customCell.js
  // parameters : objecto con los parametros que se van a mapear en la celda
  // dataSource : array de objetos a listar
  // selectable : aparecera el cusror de seleccion en hover
  // selectedStyle : estilo de la celda cuando sea seleccionda
  // cellHover : estilo de la celda en hover
  // selectSeveral : se pueden seleccionar varias celdas??
  // searching : parametro a buscar
  // searchingValue : propiedad del objeto donde se va a buscar
  // onSelectItem : funcion que se ejecutara cuando se seleccione una celda
  // onDoubleClick : funcion que se ejecutara cuando se de doble click una celda
  // onActionInCell : funcion para poder hacer otra cosa en la celda
  // orderBy : ordernar por propiedad
  // orderForm : true : ascendente, false : descendente
  constructor(props) {
    super(props);
    this.language = new Singleton();
    this.state = {
      searching: (this.props.searching || ""),
      searchingValue: (this.props.searchingValue || ""),
      orderBy: (this.props.orderBy || ""),
      orderForm: this.props.orderForm,
      selectedStyle: (this.props.selectedStyle || "defaultSelected"),
      cellHover: (this.props.cellHover || "hoverGray"),
      dataSource: [],
      tamanio: 25,
      pageIndex: 1,
      pagination: this.props.pagination,

    }

    
    //this.selectedItem = false;
    this.canDoubleClick = false;
    this.timerDoubleClick = null;
    this.pageSizes = [
      {
        label: "25",
        value: "25"
      },
      {
        label: "50",
        value: "50"
      },
      {
        label: "75",
        value: "75"
      },
      {
        label: "100",
        value: "100"
      }];

    this.lastRecord = 0;
    this.dataInPage = [];
    this.totalRecords = 0;
    this.firstRecord = 1;
    this.pageCount = 0;
    this.canNextPage = true;
    this.canPreviousPage = false;
    this.handleChange = this.handleChange.bind(this);
    this.labelfirstRecord = 0,
    this.labelTotalRecord = 0
  }
  componentDidMount() {
    this.mapDataSource(this.props.dataSource);
    if (this.props.onRef) {
      this.props.onRef(this)
    }


  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) {
      return;
    }
    this.setState({
      searching: nextProps.searching,
      searchingValue: (typeof (nextProps.searchingValue) !== "undefined" ? nextProps.searchingValue : this.state.searchingValue),
      orderBy: (typeof (nextProps.orderBy) !== "undefined" ? nextProps.orderBy : this.state.orderBy),
      orderForm: (typeof (nextProps.orderForm) !== "undefined" ? nextProps.orderForm : this.state.orderForm),
    });
    if (nextProps.dataSource !== this.props.dataSource) {
      this.mapDataSource(nextProps.dataSource);
    }
  }
  componentDidUpdate(prevState) {


    if (prevState.tamanio !== this.state.tamanio || prevState.pageIndex !== this.state.pageIndex) {
      this.renderTableItems();

    }

  }
  mapDataSource(dataSourceMap) {
    for (let i in dataSourceMap) {
      dataSourceMap[i]["selectionActive"] = false;
    }
    this.setState({ dataSource: dataSourceMap });
  }
  selectItem(item) {
    if (this.props.selectedItem !== item) {
      if (!this.props.selectSeveral) {
        let arrayState = [...this.state.dataSource];
        for (let i in arrayState) {
          arrayState[i].selectionActive = (JSON.stringify(this.state.dataSource[i]) === JSON.stringify(item));
        }
        this.setState({ dataSource: arrayState });
      } else {
        item["selectionActive"] = !item["selectionActive"];
      }

      if (this.props.onSelectItem) {
        this.props.onSelectItem(item);
      }
    }
  }
  findElements(item) {
    let image = "";
    for (let i in item) {
      if (item[i] && item[i].toString().indexOf(".svg") !== -1) {
        image = item[i];
      }
    }
    let keysSearch = Object.keys(item).filter(key => { return key.indexOf(this.state.searchingValue) !== -1 });

    var stringify = JSON.stringify(item, keysSearch);
    for (let key in keysSearch) {
      stringify = stringify.replace(keysSearch[key], '');
    }
    stringify = stringify.replace(image, '').replace(/[^a-zA-Z0-9]/g, "").replace('false', '').replace('true', '');

    return (stringify.toLowerCase().indexOf(this.state.searching.toLowerCase()) !== -1);
  }

  paginator() {
    this.totalRecords = this.state.dataSource.length; //total de datos
    this.pageCount = Math.ceil(this.state.dataSource.length / this.state.tamanio); //total de paginas

    if (this.state.dataSource.length <= this.state.tamanio) {//tamanio esrows per page

      this.canNextPage = false;
      this.canPreviousPage = false;
      this.dataInPage = this.state.dataSource;
      this.lastRecord = this.state.tamanio;
    } else {
      this.canNextPage = this.state.pageIndex < this.pageCount;
      this.canPreviousPage = this.state.pageIndex > 1;


      if (this.state.pageIndex === 1) {
        this.dataInPage = this.state.dataSource.slice(0, this.state.tamanio)
        this.firstRecord = 1;
        this.lastRecord = this.state.tamanio;

      } else {
        let inicio = ((this.state.tamanio) * (this.state.pageIndex - 1))
        let fin = ((this.state.tamanio) * (this.state.pageIndex))
        this.dataInPage = this.state.dataSource.slice(inicio, fin)
        this.lastRecord = this.state.pageIndex * this.dataInPage.length;
        this.firstRecord = this.state.tamanio * (this.state.pageIndex - 1) + 1
        this.lastRecord = this.state.tamanio * (this.state.pageIndex)
      }
    }
    this.labelfirstRecord = this.totalRecords === 0 ? 0 : this.firstRecord;
    this.labelTotalRecord = this.totalRecords === 0 ? 0 : (this.totalRecords < this.lastRecord ? this.state.dataSource.length : this.lastRecord);
  }

  renderTableItems() {

    if (this.state.dataSource !== null && this.state.dataSource !== undefined) {
      if (this.state.pagination) {
        this.paginator();
      }
      let orderBy = this.state.orderBy;
      if (orderBy) {
        this.state.dataSource.sort((a, b) => (this.state.orderForm ? a[this.state.orderBy].localeCompare(b[this.state.orderBy])
          : b[this.state.orderBy].localeCompare(a[this.state.orderBy])))
        if (this.state.pagination) {
          this.paginator();
        }
      }
      var dataSourceVar = this.state.pagination ? this.dataInPage : this.state.dataSource;
      if (this.state.searching != null) {
        dataSourceVar = dataSourceVar.filter(this.findElements.bind(this));
      }
      return dataSourceVar.map((item, i) =>
        CUSTOM_CELLS[this.props.customCell](
            item,
            this.props.parameters,
            (this.props.selectable ? "selectable " : "") + (item.selectionActive ? this.state.selectedStyle : this.state.cellHover),
            this.selectItem.bind(this),
            this.props.onActionInCell,
            this.props.onDoubleClick && (() => this.props.onDoubleClick(item)),
            i
        ));
    }

  }

  gotoPage(page) {
    this.state.pageIndex = page;

    this.setState({ pageIndex: page });
  }
  previousPage() {
    this.setState({ pageIndex: this.state.pageIndex - 1 });

  }
  nextPage() {
    this.setState({ pageIndex: this.state.pageIndex + 1 });

  }
  handleChange(e) {
    this.setState({ tamanio: e.target.value });
    this.setState({ pageIndex: 1 });
  }



  render() {
    return (
      <div className={"tableComponent " + (this.props.disabled ? "disabled" : "")}>
        <ul className="listTable">
          {this.renderTableItems()}
        </ul>

        {this.state.pagination && (
          <div className="pagination" id="pagination" >
            <div className="rowsPerPage">
              {this.language.getText("GUICallHistoryrowsPerPage")} <select onChange={this.handleChange}>
                {this.pageSizes.map((option) => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>


            <div className="pages">
              <span >
                <strong>
                  {this.labelfirstRecord} - {this.labelTotalRecord} {this.language.getText("GUICallHistoryof")} {this.totalRecords}
                </strong>
              </span>
            </div>

            <div className="buttonsPagination">

              <button className="btnP" onClick={() => this.gotoPage(1)} disabled={!this.canPreviousPage}>
                <img src={firstPage} alt="First Page" className={"iconL " + (this.canPreviousPage ? "" : "btnDisabled")} />
              </button>{' '}
              <button className="btnP" onClick={() => this.previousPage()} disabled={!this.canPreviousPage}>

                <img src={leftArrow} alt="Last Page" className={"iconS " + (this.canPreviousPage ? "" : "btnDisabled")} />
              </button>{' '}
              <button className="btnP" onClick={() => this.nextPage()} disabled={!this.canNextPage}>
                <img src={rightArrow} alt="Next Page" className={"iconS " + (this.canNextPage ? "" : "btnDisabled")} />
              </button>{' '}
              <button className="btnP" onClick={() => this.gotoPage(this.pageCount)} disabled={!this.canNextPage}>
                <img src={lastPage} alt="Last Page" className={"iconL " + (this.canNextPage ? "" : "btnDisabled")} />
              </button>{' '}
            </div>

          </div>
        )}

      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/TableComponent.jsx